module.exports = __webpack_public_path__ + "static/media/finalizando.51ff90f7.png";